module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "halftitlepage",
      "id": "bkht"
    }
  }, [_c('h1', {
    staticClass: "bkht"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pi"
    }
  }), _vm._v("Pillars of Cloud and Fire")]), _vm._v(" "), _c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("RELIGION AND SOCIAL TRANSFORMATION")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("General Editors: Anthony B. Pinn and Stacey M. Floyd-Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Prophetic Activism: Progressive Religious Justice Movements in Contemporary America")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Helene Slessarev-Jamir")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("All You That Labor: Religious Activists and Theological Ethics in the U.S. Living Wage Movement")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("C. Melissa Snarr")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Blacks and Whites in Christian America: How the Legacy of Discrimination Has Shaped African Americans’ Religious Thoughts and Practices")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("James E. Shelton and Michael O. Emerson")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Pillars of Cloud and Fire: The Politics of Exodus in African American Biblical Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Herbert Robinson Marbury")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c32cc9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marbury-0002.vue
// module id = 57
// module chunks = 0